import React, { useEffect } from 'react'
import { CustomKitLayoutProps } from '../../lib/type'
import { DeviceSelection } from '../DeviceSelection'
import { AddOnsStep } from '../AddOnsStep'
import p from './Multistep.module.scss'
import s from '@pagestyles/Checkout.module.scss'
import cn from 'classnames'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import { FlavoursStep } from '../FlavoursStep'

export const MultistepProgress = ({
    product,
    selectedOptions,
    setSelectedOptions,
    bundlePrice,
    setSelectedBundlePrice,
    setOrderMode,
    addOns,
    setAddOns,
    addProductHandler,
    orderMode,
    isAddToCartInProgress
}: CustomKitLayoutProps): JSX.Element => {
    // @ts-expect-error
    const { bundleStep, setBundleStep } = useAlfakherContext()

    const isDevicesOrAccessories = product?.items?.find(
        (item) =>
            item?.ooka_product_option == 'device' ||
            item?.ooka_product_option == 'accessories'
    )
    const isPodExist = product?.items?.find(
        (item) => item?.ooka_product_option == 'pods'
    )
    const isFavourite = product?.is_flavour_kit // product.isFavourite

    const isStarterKit =
        product?.is_custom_kit && product?.sku === 'Starter-kit'

    const isUpsell =
        product?.upsell_products?.length && product?.upsell_products?.length > 0
    useEffect(() => {
        window.scrollTo({
            behavior: 'smooth',
            top: 0
        })
    }, [bundleStep])
    const renderer = [
        ...(isDevicesOrAccessories
            ? [
                  {
                      title: '1',
                      content: (
                          <DeviceSelection
                              step={bundleStep}
                              setStep={setBundleStep}
                              product={product}
                              selectedOptions={selectedOptions}
                              setSelectedOptions={setSelectedOptions}
                              addOns={addOns}
                              addProductHandler={addProductHandler}
                              isAddToCartInProgress={isAddToCartInProgress}
                              isFlavourExist={!!isPodExist}
                              isStarterKit={!!isStarterKit}
                          />
                      )
                  }
              ]
            : []),
        ...(isPodExist && !isStarterKit
            ? [
                  {
                      title: '2',
                      content: (
                          <FlavoursStep
                              step={bundleStep}
                              setStep={setBundleStep}
                              product={product}
                              selectedOptions={selectedOptions}
                              setSelectedOptions={setSelectedOptions}
                              addOns={addOns}
                              addProductHandler={addProductHandler}
                              isAddToCartInProgress={isAddToCartInProgress}
                              isFavourite={isFavourite}
                          />
                      )
                  }
              ]
            : []),
        ...(isUpsell
            ? [
                  {
                      title: '3',
                      content: (
                          <AddOnsStep
                              setStep={setBundleStep}
                              step={bundleStep}
                              product={product}
                              addOns={addOns}
                              setAddOns={setAddOns}
                              addProductHandler={addProductHandler}
                              isAddToCartInProgress={isAddToCartInProgress}
                              selectedOptions={selectedOptions}
                              setSelectedOptions={setSelectedOptions}
                              isFavourite={isFavourite}
                          />
                      )
                  }
              ]
            : [])
    ]

    const header = () => {
        return (
            <div className={p['checkout-breadcrumb']}>
                <ul>
                    {renderer.map((item, index) => {
                        return (
                            <li
                                role="presentation"
                                onKeyDown={() => {
                                    if (bundleStep > index) {
                                        setBundleStep(index)
                                    }
                                }}
                                className={
                                    bundleStep >= index
                                        ? cn(
                                              p['active-breadcrumb'],
                                              'cursor-pointer'
                                          )
                                        : 'cursor-pointer'
                                }
                                key={item.title}
                                onClick={() => {
                                    if (bundleStep > index) {
                                        setBundleStep(index)
                                    }
                                }}
                            >
                                <div className={p['breadcrumb-divider']} />
                            </li>
                        )
                    })}
                    <li />
                </ul>
            </div>
        )
    }
    return (
        <div className={s[`step-${bundleStep}`]}>
            <div>{header()}</div>
            <div className={p['multi-step']}>
                {renderer?.[bundleStep].content}
            </div>
            <div />
        </div>
    )
}
